module.exports = __webpack_public_path__ + "img/Red Sox.c4a80bab.png";